import { z } from "zod";

// Apart from the rest of the schemas, whose messages bring the whole of the payslips copy: the
// payslip routes validate their search with this, and a route's search rides in every first load.

/** A calendar month, `YYYY-MM`. */
export const MONTH = /^\d{4}-(0[1-9]|1[0-2])$/;

/**
 * A month in the address; an unreadable one falls back to the default month. Its own key, since
 * the month kept across payslip pages must not be Attendance's or a person's.
 */
export const payslipsSearch = z.object({
  payMonth: z.string().regex(MONTH).optional().catch(undefined),
});

/** The month's address also names the slip open under its row. */
export const payslipMonthSearch = payslipsSearch.extend({
  slip: z.string().max(64).optional().catch(undefined),
});
